import api from "api";
import { useMutation } from "react-query";

export type ExerciseState = "draft" | "in_review" | "approved" | "rejected";

export interface Vars {
  id: number;
  state: ExerciseState;
}

export const usePutExerciseState = () =>
  useMutation((data: Vars) => {
    // @ts-ignore
    return api("PUT /exercises/{id}/state", {
      params: [data.id],
      data: {
        state: data.state,
      },
      root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
    });
  });
